import { Button, Input, Select, StatusBadge } from "@swot/base-components";
import type { CmtsGridFilterControl, CmtsGridFilterOption } from "./CmtsSmartDataGridTypes.js";

export function CmtsSmartDataGridToolbar<TRecord extends Record<string, unknown>>(props: {
  title: string;
  subtitle?: string | undefined;
  searchText: string;
  searchPlaceholder?: string | undefined;
  searchable: boolean;
  exportable: boolean;
  refreshable: boolean;
  filterSummary: readonly string[];
  filters: readonly (CmtsGridFilterControl<TRecord> & { resolvedOptions: readonly CmtsGridFilterOption[] })[];
  filterValues: Record<string, string>;
  onSearchChange: (text: string) => void;
  onFilterChange: (filterId: string, value: string) => void;
  onClearFilters: () => void;
  onExport?: (() => void | Promise<void>) | undefined;
  onRefresh?: (() => void | Promise<void>) | undefined;
}) {
  const hasActiveFilters = props.searchText.trim().length > 0 || Object.values(props.filterValues).some((value) => value && value !== "all");
  return (
    <div className="cmts-smart-grid-toolbar">
      <div className="cmts-smart-grid-titleblock"><h3>{props.title}</h3>{props.subtitle ? <p>{props.subtitle}</p> : null}</div>
      <div className="cmts-smart-grid-controls">
        {props.searchable ? <div className="cmts-smart-grid-search"><Input label="Search" value={props.searchText} placeholder={props.searchPlaceholder ?? "Search records"} onChange={(event) => props.onSearchChange(event.currentTarget.value)} /></div> : null}
        {props.filters.map((filter) => (
          <div key={filter.id} className="cmts-smart-grid-filter-select">
            <Select
              label={filter.label}
              value={props.filterValues[filter.id] ?? "all"}
              onChange={(event) => props.onFilterChange(filter.id, event.currentTarget.value)}
              aria-label={`Filter by ${filter.label}`}
              options={[
                { value: "all", label: filter.placeholder ?? `All ${filter.label}` },
                ...filter.resolvedOptions.map((option) => ({ value: option.value, label: `${option.label}${typeof option.count === "number" ? ` (${option.count})` : ""}` })),
              ]}
            />
          </div>
        ))}
        {hasActiveFilters ? <Button label="Clear filters" variant="secondary" onClick={props.onClearFilters} /> : null}
        {props.refreshable ? <Button label="Refresh" variant="secondary" onClick={props.onRefresh} /> : null}
        {props.exportable ? <Button label="Export" variant="secondary" onClick={props.onExport} /> : null}
      </div>
      {props.filterSummary.length > 0 ? <div className="cmts-smart-grid-filter-chips">{props.filterSummary.map((chip) => <StatusBadge key={chip} label={chip} tone="info" />)}</div> : null}
    </div>
  );
}
